import { render, staticRenderFns } from "./SubmenuTreeResponsive.vue?vue&type=template&id=2f5af320&scoped=true"
import script from "./SubmenuTreeResponsive.vue?vue&type=script&lang=js"
export * from "./SubmenuTreeResponsive.vue?vue&type=script&lang=js"
import style0 from "./SubmenuTreeResponsive.vue?vue&type=style&index=0&id=2f5af320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5af320",
  null
  
)

export default component.exports